import React,{createRef, forwardRef,useImperativeHandle,useEffect, useState,useRef } from 'react';
import { Form,Modal} from "reactstrap";
import { Controller,useForm } from "react-hook-form";

import Swal from 'sweetalert2';
import API from '../../API';
import { TimeFormat,DateFormat, DateThai,DateFormatJSON,MobileFormat, NumberFormat,RootURL } from '../../Utils/Function';
import "react-datepicker/dist/react-datepicker.css";
import {RoleList,RoleName} from '../../Utils/Status';
const UserInfoCard = forwardRef((props,ref) =>{
    const { register, handleSubmit, watch, reset, getValues,setValue, control, formState: { errors } } = useForm();
    
    const [ModalState,setModalState] = useState(false);
    const [_Detail,setDetail] = useState(null);
    const [_Role,setRole] = useState(0);
    const [_StoreList,setStoreList] = useState([]);
    const [_Status,setStatus] = useState(null);
    const _ref = useRef();
    useEffect(() => {
        (async () => {
            _LoadStoreList();
        })();

        return ()=>{ }
    }, []);
    
    useImperativeHandle(ref, () => ({
        Show(StoreID){
            setStoreList([]);
            setDetail(null);
            _LoadStoreList();
            if(StoreID != null){
                _Load(StoreID);
            }else{
                setValue("StoreName",null);
                setValue("StoreCode",null);
                setValue("Description",null);
                setValue("StoreID",null);
                setValue("Remark",null);
                setValue("GPShare", null);
                setModalState(true);
            }
        },

    }));
    const _LoadStoreList = async()=>{
        setStoreList([]);
        API({method : "get",url:"/Admin/Store/List"}).then(res=>{
                if (res.status !== 200) {
                    return;
                }
    
                if (!res.data.Status) {
                    return;
                }
            setStoreList(res.data.Data);
        }).catch(res => {
                return;
        });
    }
    const _Load = async(StoreID) =>{
        Swal.showLoading();
        API({method : "get",url:"/Admin/Store/"+StoreID}).then(res=>{
            Swal.close();
            if (!res.data.Status) {
                Swal.fire({
                    title: res.data.Message,
                    icon: 'error'
                });
                return;
            }
            const _StoreObj = res.data.Data;
            setDetail(res.data.Data);
            setValue("StoreName",_StoreObj.StoreName.trim());
            setValue("StoreCode",_StoreObj.StoreCode.trim());
            setValue("Description",_StoreObj.Description);
            setValue("GPShare",Number(_StoreObj.Gpshare));
            setValue("Remark",_StoreObj.Remark);
            setStatus(_StoreObj.Status);
            window.setTimeout(()=>{
                setModalState(true);
            },500);
        }).catch(res => {
            Swal.fire({
                title: res,
                icon: 'error'
            });
            return;
        });
    }
   
    const _UpdateStatus = async(method) => {
        if (_Detail == null) return;
        API({ method, url: '/Admin/Store/' + _Detail.StoreId + '/Status' }).then(res => {
            if (!res.data.Status) { Swal.fire({ icon: 'error', title: res.data.Message }); return; }
            setStatus(method === 'put' ? 1 : 2);
            if(props.update != undefined){
                try{
                    props.update(res.data.Data);
                }catch(e){
                    console.log(e);
                }
            }
        }).catch(() => { Swal.fire({ icon: 'error', title: 'การเชื่อมต่อผิดพลาด' }); });
    };

    const _Save = async()=>{
        if(getValues('StoreCode') == undefined || getValues('StoreCode') === ""){
            Swal.fire({
                icon: 'error',
                title: 'โปรดตรวจสอบ รหัสร้านค้า'
            });
            return;
        }
        if(getValues('StoreName') == undefined || getValues('StoreName') === ""){
            Swal.fire({
                icon: 'error',
                title: 'โปรดตรวจสอบ ชื่อร้านค้า'
            });
            return;
        }
        let _reqObj = {
            StoreID : (_Detail != null ? _Detail.StoreId:null),
            StoreCode: getValues('StoreCode'),
            StoreName: getValues('StoreName'),
            GPShare: Number(getValues('GPShare')),
            Description:getValues('Description'),
            Remark: getValues('Remark'),
        }
        Swal.fire({
            icon: 'warning',
            title: 'ต้องการบันทึก หรือไม่ ?',
            text : '',
            showCancelButton : true,
            confirmButtonText: 'บันทึก',
            confirmButtonColor:'#d33',
            cancelButtonText:'ยกเลิก'
        }).then((r)=>{
            if(!r.isConfirmed){
                return;
            }

            API({method : 'post',url:'/Admin/Store/Save',data:_reqObj}).then(res=>{
                if(!res.data.Status){
                    Swal.fire({
                        icon: 'error',
                        title: res.data.Message
                    });
                    return;
                }
                _Load(res.data.Data.StoreId);
                Swal.fire({
                    icon: 'success',
                    title: 'บันทึกสำเร็จ',
                });
                //setModalState(false);
                //_ClearValuAction();
                if(props.update != undefined){
                    try{
                        props.update(res.data.Data);
                    }catch(e){
                        console.log(e);
                    }
                }
            }).catch(res => {
                if(res.response.data != undefined){
                    Swal.fire({
                        icon: 'error',
                        title: res.code,
                        text: res.response.data.Message
                    });
                }else{
                    Swal.fire({
                        icon: 'error',
                        title: 'การเชื่อมต่อผิดพลาด',
                        text: res.message+' ['+res.code+']',
                    });
                }
            });
        });
    }

    return (
        <>
        <Modal isOpen={ModalState} className={'modal-xl'} centered={true} unmountOnClose={true}>
            <div className="modal-header">
                <h5 className="modal-title">ข้อมูลร้านค้า :: {(_Detail != null?_Detail.StoreName:"")}</h5>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"  onClick={()=>{setModalState(false)}}></button>
            </div>
            <div className='modal-body' style={{'minHeight':'500px'}}>
                <Form onSubmit={handleSubmit(_Save)} className='row g-3'>
                    <div className='row justify-content-center mt-2 mb-2'>
                        <div className='col-3 text-end mr-2'>
                            <h3>รหัสร้านค้า</h3>
                        </div>
                        <div className='col-8'>
                            <input type='text' className='form-control' readOnly={(_Detail != null && _Detail.UserID != null ? true: false)}  {...register("StoreCode", { required: true })} />
                        </div>
                    </div>
                    <div className='row justify-content-center mt-2 mb-2'>
                        <div className='col-3 text-end mr-2'>
                            <h3>ชื่อร้านค้า</h3>
                        </div>
                        <div className='col-8'>
                            <input type='text' className='form-control' {...register("StoreName", { required: true })} />
                        </div>
                    </div>
                    <div className='row justify-content-center mt-2 mb-2'>
                        <div className='col-3 text-end mr-2'>
                            <h3>เปอร์เซ็น</h3>
                        </div>
                        <div className='col-2'>
                            <input type='number' className='form-control text-center' min={0} max={100} {...register("GPShare", { required: true })} />
                        </div>
                        <div className='col-6'></div>
                    </div>
                    <div className='row justify-content-center mt-2 mb-2'>
                        <div className='col-3 text-end mr-2'>
                            <h3>รายละเอียด</h3>
                        </div>
                        <div className='col-8'>
                            <Controller name="Description" control={control} rules={{required:false}} render={({field})=>(
                                <textarea className="form-control" autoComplete="off"  onChange={(e)=>field.onChange(e)} defaultValue={field.value}/>
                            )} />
                        </div>
                    </div>
                    <div className='row justify-content-center mt-5 mb-2'>
                        <div className='col-3 text-end mr-2'>
                            <h3>หมายเหตุ</h3>
                        </div>
                        <div className='col-8'>
                            <Controller name="Remark" control={control} rules={{required:false}} render={({field})=>(
                                <textarea className="form-control" autoComplete="off"  onChange={(e)=>field.onChange(e)} defaultValue={field.value}/>
                            )} />
                        </div>
                    </div>
                    {_Detail != null && (
                        <div className='row justify-content-center mt-2 mb-2'>
                            <div className='col-3 text-end mr-2'>
                                <h3>สถานะ</h3>
                            </div>
                            <div className='col-8 d-flex align-items-center gap-3'>
                                <div className='form-check form-switch mb-0'>
                                    <input
                                        className='form-check-input'
                                        type='checkbox'
                                        role='switch'
                                        style={{ width: '3rem', height: '1.5rem', cursor: 'pointer' }}
                                        checked={_Status === 1}
                                        onChange={() => _UpdateStatus(_Status === 1 ? 'delete' : 'put')}
                                    />
                                </div>
                                <span className={`badge fs-6 ${_Status === 1 ? 'bg-success' : 'bg-danger'}`}>
                                    {_Status === 1 ? 'เปิดใช้งาน' : 'ปิดใช้งาน'}
                                </span>
                            </div>
                        </div>
                    )}
                    <div className='row mt-4'>
                        <div className='col-12'>
                            <div className='btn-group btn-group-lg float-end'>
                                <button type='submit' className='btn btn-success text-white'>บันทึกข้อมูล</button>
                            </div>
                        </div>
                    </div>
                </Form>
            </div>
        </Modal>
        </>)
        
});

export default React.memo(UserInfoCard)